import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10f12d82"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-values" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "我们的价值", -1))
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "list" }
const _hoisted_5 = ["src"]

import { ref } from "vue";
import IconDown from "@/components/SvgIcon/IconDown.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeValues',
  setup(__props) {

const listConfig = [
  {
    title: "安全",
    descript: "我们承诺并肩负重任，确保用户的健康管理信息保存妥当。",
    color: "#00b3d8",
  },
  {
    title: "创新",
    descript:
      "我们深信凭着不断创造新型独特的产品，必定可以重塑和推进健康管理界迈步向前。",
    color: "#00b1bd",
  },
  {
    title: "健康",
    descript: "以技术作为催化剂，鼓励我们的社区持续强大、健康和幸福的生活。",
    color: "#00afa2",
  },
  {
    title: "关怀",
    descript: "我们关心用户的日常生活，希望系统化的管理能为他们解忧。",
    color: "#00ac86",
  },
  {
    title: "成长",
    descript:
      "不单只作为产品，而是作为一个健康强壮的个人团队不断增值和进步，继续前进。",
    color: "#00aa6b",
  },
  {
    title: "效率",
    descript: "我们提供最有效的技术，为用户提供便利和提高他们生活质素的服务。",
    color: "#00a850",
  },
];
const isShowP = ref<null | number>(null);
const phoneClick = (index: number | null) => {
  if (isShowP.value === index) {
    isShowP.value = null;
  } else {
    isShowP.value = index;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", null, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(listConfig, (item, index) => {
        return _createElementVNode("li", {
          key: index,
          class: _normalizeClass(`li-${index + 1}`),
          onClick: ($event: any) => (phoneClick(index))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              src: require(`@/assets/value${index + 1}.png`),
              alt: ""
            }, null, 8, _hoisted_5),
            _createElementVNode("h3", null, _toDisplayString(item.title), 1),
            _createVNode(IconDown, {
              color: item.color,
              size: 14,
              class: "icons"
            }, null, 8, ["color"])
          ]),
          _createElementVNode("p", {
            class: _normalizeClass(`${isShowP.value === index ? 'show-p' : ''}`)
          }, _toDisplayString(item.descript), 3)
        ], 10, _hoisted_3)
      }), 64))
    ])
  ]))
}
}

})